var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleItemDisplayActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 124,
    viewBox: "0 0 164 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 162,
    height: 122,
    rx: 5,
    fill: "#F0F9F5",
    stroke: "#68C598",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 47,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 54,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 61,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 81,
    width: 36,
    height: 9,
    rx: 4.5,
    fill: "#68C598"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 34,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#BBBBBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 34H27V79H72V34ZM70.0582 36.025H29.0263V77.0875H70.0582V36.025Z",
    fill: "#68C598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0633 65.2765L44.1472 51.9023L31.29 71.1881H48.9253L48.8572 71.2854H66.8572L57.8572 58.4282L53.0633 65.2765Z",
    fill: "#68C598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4885 54.5848C63.3619 54.5848 65.6913 52.2791 65.6913 49.435C65.6913 46.5908 63.3619 44.2852 60.4885 44.2852C57.615 44.2852 55.2856 46.5908 55.2856 49.435C55.2856 52.2791 57.615 54.5848 60.4885 54.5848Z",
    fill: "#68C598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleItemDisplayActive);
export default __webpack_public_path__ + "static/media/single-item-display-active.5334df1de217c6db18cf7d439e62fa3c.svg";
export { ForwardRef as ReactComponent };